/**
 * Disparar la descarga de un blob desde el navegador.
 *
 * Estaba dentro de adminExportService, privado. Salio aqui cuando el export de influencer
 * -que NO pasa por la red: construye el ZIP en memoria- necesito lo mismo. Dos copias del
 * mismo baile de createObjectURL / click / revoke es justo lo que acaba fugando memoria en
 * una de las dos.
 */

/** Lee el nombre de fichero de un Content-Disposition, con recambio si no viene. */
export function parseContentDispositionFilename(
  contentDisposition: string | undefined,
  fallback: string
): string {
  const match = contentDisposition?.match(/filename="(.+)"/);
  return match?.[1] ?? fallback;
}

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
}
